import { http } from 'src/utils/request';

/**
 * 获取表列表
 * @returns {Promise<Array>} 表列表数据
 */
export const fetchTableListService = async () => {
  try {
    const url = '/api/erp/v1/tables/list';
    const response = await http.get(url);
    // 确保返回的数据格式正确
    if (response && response.data) {
      return {
        success: true,
        data: Array.isArray(response.data) ? response.data : [],
        message: '获取成功',
      };
    }
    return {
      success: false,
      data: [],
      message: '获取表列表失败：响应格式错误',
    };
  } catch (error) {
    console.error('获取表列表失败:', error);
    return {
      success: false,
      data: [],
      message: error.message || '获取表列表失败',
    };
  }
};

/**
 * 获取视图数据
 * @param {Object} request - 请求参数
 * @param {string} request.viewId - 视图ID
 * @param {number} [request.pageSize] - 每页大小
 * @param {number} [request.pageNum] - 页码
 * @param {Array<{field: string, operator: string, value: any}>} [request.conditions] - 查询条件
 * @param {Object} config - 配置参数
 * @param {boolean} config.showLoading - 是否显示全局 loading，默认为 true
 * @returns {Promise<Object>} 视图数据
 */
export const fetchViewDataService = async (request, config = {}) => {
  try {
    const { showLoading = true, ...otherConfig } = config;
    const url = '/api/erp/v1/view/pageList';
    const response = await http.post(url, request, {
      ...otherConfig,
      headers: {
        ...otherConfig.headers,
        'X-Show-Loading': showLoading.toString(),
      },
    });
    return response.data;
  } catch (error) {
    console.error('获取视图数据失败:', error);
    throw new Error(error.message || '获取视图数据失败');
  }
};

/**
 * 获取表详情
 * @param {string} tableId - 表ID
 * @returns {Promise<Object>} 表详情数据
 */
export const fetchTableDetailService = async tableId => {
  try {
    if (!tableId) {
      throw new Error('表ID不能为空');
    }
    const url = `/api/erp/v1/tables/detailById/${tableId}`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error('获取表详情失败:', error);
    throw new Error(error.message || '获取表详情失败');
  }
};
